import { swatches } from "@/mocks/colors";

const REPRESENTATIVES = ["HLC-0102", "HLC-0201", "HLC-0301", "HLC-0401", "HLC-0501", "HLC-0602"];

const toneBadge = (tone: string) =>
  tone === "冷调" ? "bg-secondary-100 text-secondary-900"
    : tone === "暖调" ? "bg-accent-100 text-accent-900"
      : "bg-background-200 text-foreground-700";

export default function Compare() {
  const rows = swatches.filter((s) => REPRESENTATIVES.includes(s.code));

  return (
    <section id="compare" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <p className="flex items-center gap-3 text-accent-700 text-xs tracking-display uppercase">
              <span className="font-number text-lg">03</span>
              <span className="inline-block w-8 h-px bg-accent-500" />
              跨系对照
            </p>
            <h2 className="mt-4 font-serif text-foreground-950 text-2xl md:text-[32px] font-semibold">
              六色系代表黑 · 一张表看清
            </h2>
            <p className="mt-3 text-[15px] text-foreground-600 max-w-2xl">
              需要横向比对不同色系的深黑与底调差异时，看这张对照表最省事，按明度与冷暖快速锁定目标。
            </p>
          </div>
          <a
            href="#atlas"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 text-foreground-900 px-4 py-2 text-sm hover:border-accent-500 hover:text-accent-700 transition-colors"
          >
            返回完整图鉴
          </a>
        </div>

        <div className="mt-8 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full min-w-[760px] text-sm border-collapse">
            <caption className="sr-only">黑料色六色系代表色号跨系对照表</caption>
            <thead>
              <tr className="bg-background-100 text-foreground-500 text-left">
                <th className="px-4 py-3 font-medium text-xs tracking-wide">色系</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">色号</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">名称</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">色样</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">HEX</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">明度</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">底调</th>
                <th className="px-4 py-3 font-medium text-xs tracking-wide">光泽</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((s, i) => (
                <tr key={s.id} className={`border-t border-background-200 hover:bg-background-100/60 transition-colors ${i % 2 ? "bg-background-50" : ""}`}>
                  <td className="px-4 py-3 text-foreground-900 font-medium">{s.categoryId === "warm" ? "暖黑" : s.categoryId === "ink" ? "玄青" : s.categoryId === "carbon" ? "炭黑" : s.categoryId === "obsidian" ? "曜石" : s.categoryId === "graphite" ? "石墨" : "烟灰"}</td>
                  <td className="px-4 py-3 font-number text-foreground-600">{s.code}</td>
                  <td className="px-4 py-3 font-serif text-foreground-950">{s.name}</td>
                  <td className="px-4 py-3">
                    <span className="inline-block w-8 h-8 rounded-md border border-background-200" style={{ backgroundColor: s.hex }} />
                  </td>
                  <td className="px-4 py-3 font-number text-foreground-800">{s.hex}</td>
                  <td className="px-4 py-3 text-foreground-600">{s.lightness}%</td>
                  <td className="px-4 py-3">
                    <span className={`text-[11px] px-2 py-0.5 rounded-full ${toneBadge(s.tone)}`}>{s.tone}</span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600">{s.sheen}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-5 flex gap-3 items-start rounded-lg bg-background-50 border border-background-200 px-5 py-4">
          <i className="ri-information-line text-accent-600 mt-0.5" />
          <p className="text-[13px] leading-6 text-foreground-600">
            关于「印黑」：追求更实更深的印刷黑时，可在 100% K 的基础上加少量 C / M / Y 形成富黑，以免纯黑在纸张上偏灰。
            各色号 CMYK 分色值请在图鉴色块详情中查看。
          </p>
        </div>
      </div>
    </section>
  );
}